import { baseTheme } from './base';

// Logo importado aqui fora do objeto — evita problema com bundler
import { ReactComponent as WobaLogoSvg } from '../assets/logo-woba-preta.svg';

export const wobaTheme = {
  ...baseTheme,
  empresaId: 7015, // fallback — qualquer empresa sem tema cai aqui

  Logo: WobaLogoSvg,

  // auth, labels, fields e colors já herdados do base
  // só sobrescreve o que for diferente da Woba
};
